// src/routes/Routers.tsx
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RoutesConfig, UserProfiles } from "./types";
import { Login } from "../pages/Login";
import { Splash } from "../pages/Splash";
import { Register } from "../pages/Register";
import { ConfirmSignUp } from "../pages/ConfirmSignUp";
import Home from "../pages/Home";
import Dashboard from "../pages/Dashboard";
import DetailsPage from "../pages/DetailsPage";
import ProcessPerClientPage from "../pages/ProcessPerClientPage";
import MyProcessesPage from "../pages/MyProcessesPage";
import { Usuarios } from "../pages/Usuarios";
import { CadastrarUsuario } from "../pages/CadastrarUsuario";
import RegistroCliente from "../pages/RegistroCliente";
import { ProtectedRoute } from "./ProtectedRoute";
import { AssociarAdmin } from "../pages/AssociarAdmin";
import { AssociarAnalista } from "../pages/AssociarAnalista";
import { AssociarCliente } from "../pages/AssociarCliente";

export const Routers = () => {
  return (
    <Router>
      <Routes>
        <Route path={RoutesConfig.SPLASH.path} element={<Splash />} />
        <Route path={RoutesConfig.LOGIN.path} element={<Login />} />
        <Route path={RoutesConfig.REGISTER.path} element={<Register />} />
        <Route
          path={RoutesConfig.CONFIRMSIGNUP.path}
          element={<ConfirmSignUp />}
        />
        <Route
          path={RoutesConfig.HOME.path}
          element={
            <ProtectedRoute
              allowedProfiles={[
                UserProfiles.Admin,
                UserProfiles.Analista,
                UserProfiles.Cliente,
              ]}
            >
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.DASHBOARD.path}
          element={
            <ProtectedRoute
              allowedProfiles={[UserProfiles.Admin, UserProfiles.Analista]}
            >
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.MEUSPROCESSOS.path}
          element={
            <ProtectedRoute
              allowedProfiles={[UserProfiles.Analista, UserProfiles.Admin]}
            >
              <MyProcessesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.DETALHESPROCESSO.path}
          element={
            <ProtectedRoute
              allowedProfiles={[
                UserProfiles.Cliente,
                UserProfiles.Analista,
                UserProfiles.Admin,
              ]}
            >
              <DetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.PROCESSOSPORCLIENTE.path}
          element={
            <ProtectedRoute
              allowedProfiles={[UserProfiles.Analista, UserProfiles.Admin]}
            >
              <ProcessPerClientPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.USUARIOS.path}
          element={
            <ProtectedRoute allowedProfiles={[UserProfiles.Admin]}>
              <Usuarios />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.CADASTRARUSUARIO.path}
          element={
            <ProtectedRoute allowedProfiles={[UserProfiles.Admin]}>
              <CadastrarUsuario />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.ASSOCIARADMIN.path}
          element={
            <ProtectedRoute allowedProfiles={[UserProfiles.Admin]}>
              <AssociarAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.ASSOCIARANALISTA.path}
          element={
            <ProtectedRoute allowedProfiles={[UserProfiles.Admin]}>
              <AssociarAnalista />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.ASSOCIARCLIENTE.path}
          element={
            <ProtectedRoute allowedProfiles={[UserProfiles.Admin]}>
              <AssociarCliente />
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesConfig.REGISTROCLIENTE.path}
          element={
            <ProtectedRoute allowedProfiles={[UserProfiles.Analista]}>
              <RegistroCliente />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};
